.grid {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

/* An odd count on a 2-column grid: the last spans the row, as in the design. */
.cell:last-child:nth-child(odd) {
  grid-column: 1 / -1;
}

.tile {
  position: relative;
  display: block;
  height: 170px;
  border-radius: var(--radius-card);
  overflow: hidden;
  background: var(--border-strong);
  color: #ffffff;
}

.tile:hover {
  color: #ffffff;
}

.photo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.tile:hover .photo {
  transform: scale(1.03);
}

.shade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  background: linear-gradient(to top, rgba(var(--ink-rgb), 0.72), rgba(var(--ink-rgb), 0));
}

.caption {
  position: absolute;
  left: 14px;
  right: 12px;
  bottom: 12px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
}

.label {
  font-family: var(--font-display);
  font-weight: 600;
  /* The site's (--mood-label-size*): the longest label must fit its tile. */
  font-size: var(--mood-label-size-phone);
  line-height: 1.05;
}

.arrow {
  width: 30px;
  height: 30px;
  flex: none;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 1024px) {
  .grid {
    grid-template-columns: repeat(var(--mood-columns), minmax(0, 1fr));
    gap: 12px;
  }

  .cell:last-child:nth-child(odd) {
    grid-column: auto;
  }

  .tile {
    height: 220px;
  }

  .shade {
    height: 90px;
    background: linear-gradient(to top, rgba(var(--ink-rgb), 0.7), rgba(var(--ink-rgb), 0));
  }

  .caption {
    left: 18px;
    right: 16px;
    bottom: 16px;
    align-items: center;
    gap: 10px;
  }

  .label {
    font-size: var(--mood-label-size);
  }

  .arrow {
    width: 34px;
    height: 34px;
  }

  .arrowIcon {
    width: 14px;
    height: 14px;
  }
}
